// extracted by mini-css-extract-plugin
module.exports = {"forgot-password-info":"forgot-password_forgot-password-info__2O_Tg"};